import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, Alert } from '@mui/material';
import api from '../api/api';

interface Props {
  open: boolean;
  onClose: () => void;
  camera: { id: number; name: string; source: string; location?: string; school_id: number };
  onSaved: () => void;
}

const EditCameraDialog: React.FC<Props> = ({ open, onClose, camera, onSaved }) => {
  const [name, setName] = useState(camera.name);
  const [source, setSource] = useState(camera.source);
  const [location, setLocation] = useState(camera.location || '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setName(camera.name);
    setSource(camera.source);
    setLocation(camera.location || '');
    setError('');
  }, [camera, open]);

  const handleSave = async () => {
    setError('');
    setLoading(true);
    try {
      await api.put(`/cameras/${camera.id}`, {
        name,
        source,
        location,
        school_id: camera.school_id,
      });
      onSaved();
      onClose();
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'Failed to update camera.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Edit Camera</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField label="Name" value={name} onChange={e => setName(e.target.value)} required />
          <TextField label="Source" value={source} onChange={e => setSource(e.target.value)} required />
          <TextField label="Location" value={location} onChange={e => setLocation(e.target.value)} />
          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={loading}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCameraDialog; 